import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, CheckCircle2 } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/cgGrM6vDonxc8zFpe3vS4R/SaveClip.App_618144395_17872768035508306_3873199516963268169_n.jpg', 'https://cdn.magicpatterns.com/uploads/jj4iGnpTW9NWZK4uTh2kSi/SaveClip.App_537040841_17855327496508306_8108097126173545127_n.jpg', 'https://cdn.magicpatterns.com/uploads/5iS424GLfNat5cJvPPmK4Z/SaveClip.App_618736816_17872768044508306_362254212216313105_n.jpg', 'https://cdn.magicpatterns.com/uploads/oKwMmoJzde8KKLDjDrtsy6/SaveClip.App_536375075_17855327835508306_7054355897468831113_n.jpg', 'https://cdn.magicpatterns.com/uploads/cgGrM6vDonxc8zFpe3vS4R/SaveClip.App_618144395_17872768035508306_3873199516963268169_n.jpg', 'https://cdn.magicpatterns.com/uploads/5iS424GLfNat5cJvPPmK4Z/SaveClip.App_618736816_17872768044508306_362254212216313105_n.jpg'];
export function SocialSection() {
  return <section className="py-24 bg-kiron-black relative" data-id="element-178">
      <div className="max-w-7xl mx-auto px-6" data-id="element-179">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-181">
            <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-2" data-id="element-182">
              VIVÍ KIRON <span className="text-kiron-teal" data-id="element-183">EN ACCIÓN</span>
            </h2>
            <p className="text-xl text-gray-400 font-light tracking-wide uppercase" data-id="element-184">
              Resultados reales. Entrenamiento real.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-185">
            <a href="https://www.instagram.com/kironperformance/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-kiron-teal text-kiron-black font-oswald font-bold px-6 py-3 uppercase tracking-wider hover:scale-105 transition-transform duration-300" data-id="element-186">
              <Instagram size={20} data-id="element-187" />
              Seguinos en Instagram
            </a>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4 mb-12" data-id="element-188">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="aspect-square relative group overflow-hidden bg-kiron-darker cursor-pointer" data-id="element-189">
              <img src={img} alt={`Kiron Instagram Post ${index + 1}`} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-190" />
              <div className="absolute inset-0 bg-kiron-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-191">
                <Instagram className="text-white w-10 h-10" data-id="element-192" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col sm:flex-row justify-center items-center gap-8 py-8 border-y border-gray-800" data-id="element-193">
          <div className="flex items-center gap-3" data-id="element-194">
            <CheckCircle2 className="text-kiron-teal w-8 h-8" data-id="element-195" />
            <span className="font-oswald text-xl uppercase tracking-wider text-white" data-id="element-196">
              + de 500 alumnos entrenando actualmente
            </span>
          </div>
          <div className="hidden sm:block w-px h-12 bg-gray-800" data-id="element-197"></div>
          <div className="flex items-center gap-3" data-id="element-198">
            <CheckCircle2 className="text-kiron-teal w-8 h-8" data-id="element-199" />
            <span className="font-oswald text-xl uppercase tracking-wider text-white" data-id="element-200">
              Resultados visibles en semanas
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}